<template>
    <div class="bg-white mt-2 py-4">
        <div class="container">
            <h1>{{msg}}</h1>

            <table class="table table-hover">
                <thead class="no-border">
                <tr>
                    <th scope="col">docbox UAW ID </th>
                    <th scope="col">Datum Meldung</th>
                    <th scope="col">Mitarbeiter</th>
                    <th scope="col">Quelle</th>
                    <th scope="col">Letzter Export</th>
                    <th scope="col">Ihre Referenznummer</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th scope="row">93</th>
                    <td>18.01.2017 16:55</td>
                    <td>Chiara Ritter Ärztebesucherin</td>
                    <td>Chat</td>
                    <td>18.01.2017 16:55</td>
                    <td>
                        <input type="text" class="form-control" placeholder="1234568">
                    </td>
                    <td><button class="btn btn-link">ABBRECHEN</button></td>
                    <td><button class="btn btn-link">SPEICHERN</button></td>
                </tr>

                <tr>
                    <th scope="row">93</th>
                    <td>18.01.2017 16:55</td>
                    <td>Chiara Ritter Ärztebesucherin</td>
                    <td>Chat</td>
                    <td>18.01.2017 16:55</td>
                    <td>
                        <input type="text" class="form-control" placeholder="1234568">
                    </td>
                    <td><button class="btn btn-link">ABBRECHEN</button></td>
                    <td><button class="btn btn-link">SPEICHERN</button></td>
                </tr>

                <tr>
                    <th scope="row">93</th>
                    <td>18.01.2017 16:55</td>
                    <td>Chiara Ritter Ärztebesucherin</td>
                    <td>Chat</td>
                    <td>18.01.2017 16:55</td>
                    <td>
                        <input type="text" class="form-control" placeholder="1234568">
                    </td>
                    <td><button class="btn btn-link">ABBRECHEN</button></td>
                    <td><button class="btn btn-link">SPEICHERN</button></td>
                </tr>

                <tr>
                    <th scope="row">93</th>
                    <td>18.01.2017 16:55</td>
                    <td>Chiara Ritter Ärztebesucherin</td>
                    <td>Chat</td>
                    <td>18.01.2017 16:55</td>
                    <td>
                        <input type="text" class="form-control" placeholder="1234568">
                    </td>
                    <td><button class="btn btn-link">ABBRECHEN</button></td>
                    <td><button class="btn btn-link">SPEICHERN</button></td>
                </tr>

                <tr>
                    <th scope="row">93</th>
                    <td>18.01.2017 16:55</td>
                    <td>Chiara Ritter Ärztebesucherin</td>
                    <td>Chat</td>
                    <td>18.01.2017 16:55</td>
                    <td>
                        <input type="text" class="form-control" placeholder="1234568">
                    </td>
                    <td><button class="btn btn-link">ABBRECHEN</button></td>
                    <td><button class="btn btn-link">SPEICHERN</button></td>
                </tr>

                <tr>
                    <th scope="row">93</th>
                    <td>18.01.2017 16:55</td>
                    <td>Chiara Ritter Ärztebesucherin</td>
                    <td>Chat</td>
                    <td>18.01.2017 16:55</td>
                    <td>
                        <input type="text" class="form-control" placeholder="1234568">
                    </td>
                    <td><button class="btn btn-link">ABBRECHEN</button></td>
                    <td><button class="btn btn-link">SPEICHERN</button></td>
                </tr>

                <tr>
                    <th scope="row">93</th>
                    <td>18.01.2017 16:55</td>
                    <td>Chiara Ritter Ärztebesucherin</td>
                    <td>Chat</td>
                    <td>18.01.2017 16:55</td>
                    <td>
                        <input type="text" class="form-control" placeholder="1234568">
                    </td>
                    <td><button class="btn btn-link">ABBRECHEN</button></td>
                    <td><button class="btn btn-link">SPEICHERN</button></td>
                </tr>

                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "table",
        data() {
            return {
                msg: 'Liste UAW-Meldungen',
            }
        }
    }
</script>

<style lang="scss">
    .no-border {
        tr th {
            border-top: 0;
        }
    }

    .table-hover tbody tr {
        transition: background .2s linear;
    }
</style>


// WEBPACK FOOTER //
// src/components/table.vue